export const SMS_CHAT_CHECK_EXISTED_CHAT_START = 'SMS_CHAT_CHECK_EXISTED_CHAT_START';
export const SMS_CHAT_CHECK_EXISTED_CHAT_SUCCESS = 'SMS_CHAT_CHECK_EXISTED_CHAT_SUCCESS';
export const SMS_CHAT_CHECK_EXISTED_CHAT_FAIL = 'SMS_CHAT_CHECK_EXISTED_CHAT_FAIL';